<app-card-layout-content class="blocked-account-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <img src="../assets/images/blocked-account.png" aria-hidden="true" alt="" />
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Account bloccato</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description class="blocked-account-page__container">
      <div class="blocked-account-page__content p-d-flex p-flex-column p-jc-center p-mb-5">
        <span i18n>Oops! L’account risulta bloccato.</span>
        <span i18n>Per riattivarlo contatta l’assistenza oppure accedi con un altro indirizzo.</span>
      </div>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <div class="p-mt-auto">
    <div class="p-d-flex p-flex-column p-ai-center p-mb-3">
      <span i18n>Hai bisogno di aiuto?</span>
      <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
    </div>
    <button
      class="blocked-account-page__login-button"
      pButton
      label="Torna al login"
      i18n-label="BlockedAccount|Label button torna al login"
      (click)="onBackToLoginPageButton()"
    ></button>
  </div>
</app-card-layout-content>
